import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { rememberDemoMaturaReturnPath } from "../demo/demoMaturaResume";
import {
  MATURA_DEMO_LIMIT_MS,
  MATURA_DEMO_STARTED_AT_KEY,
} from "../demo/guestLearningLimits";

function readDemoStartedAt(createIfMissing = true) {
  if (typeof window === "undefined") return createIfMissing ? Date.now() : null;
  try {
    const stored = Number(window.sessionStorage.getItem(MATURA_DEMO_STARTED_AT_KEY));
    if (Number.isFinite(stored) && stored > 0) return stored;
    if (!createIfMissing) return null;
    const now = Date.now();
    window.sessionStorage.setItem(MATURA_DEMO_STARTED_AT_KEY, String(now));
    return now;
  } catch {
    return createIfMissing ? Date.now() : null;
  }
}

function formatRemaining(ms) {
  const seconds = Math.max(0, Math.ceil(ms / 1000));
  const minutes = Math.floor(seconds / 60);
  return `${minutes}:${String(seconds % 60).padStart(2, "0")}`;
}

export default function DemoMaturaNotice({
  compact = false,
  examMode = false,
  overviewMode = false,
  allowAdminReset = false,
  onlyIfStarted = false,
  showExpiredDialog = true,
}) {
  const [startedAt, setStartedAt] = useState(() => readDemoStartedAt(!onlyIfStarted));
  const [remaining, setRemaining] = useState(() => (
    startedAt == null ? null : Math.max(0, MATURA_DEMO_LIMIT_MS - (Date.now() - startedAt))
  ));
  const demoExpired = remaining === 0;

  const resetDemoTimer = () => {
    const now = Date.now();
    try {
      window.sessionStorage.setItem(MATURA_DEMO_STARTED_AT_KEY, String(now));
    } catch {}
    setStartedAt(now);
    setRemaining(MATURA_DEMO_LIMIT_MS);
  };

  useEffect(() => {
    if (startedAt == null) return undefined;
    const timer = window.setInterval(() => {
      setRemaining(Math.max(0, MATURA_DEMO_LIMIT_MS - (Date.now() - startedAt)));
    }, 1000);
    return () => window.clearInterval(timer);
  }, [startedAt]);

  if (startedAt == null) return null;

  return (
    <>
      <aside
        className="demo-matura-notice themed-island themed-island--primary"
        style={{
          width: "100%",
          padding: compact ? "10px 12px" : "12px 14px",
          borderRadius: 8,
          border: "1px solid rgba(255, 167, 38, 0.72)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 12,
          flexWrap: "wrap",
        }}
      >
        <div style={{ minWidth: 0 }}>
          <strong>Tryb demonstracyjny · {formatRemaining(remaining)}</strong>
          <div style={{ marginTop: 3, fontSize: "0.86rem", lineHeight: 1.4, opacity: 0.82 }}>
            {overviewMode
              ? "Pozostały czas dotyczy całego demo: ścieżki i arkusza. Załóż bezpłatne konto, aby kontynuować naukę i trwale zapisywać postęp."
              : examMode
              ? "Przez 10 minut możesz sprawdzić arkusz. W trybie demonstracyjnym odpowiedzi i wynik nie są trwale zapisywane; załóż bezpłatne konto, aby zachować postęp."
              : "Przez 10 minut możesz sprawdzić ścieżkę, ćwiczenia i quizy. Załóż bezpłatne konto, aby kontynuować naukę i trwale zapisywać cały postęp."}
          </div>
        </div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          {allowAdminReset ? (
            <button type="button" className="btn-secondary" onClick={resetDemoTimer}>
              Odśwież 10 min
            </button>
          ) : null}
          <Link className="btn-secondary" to="/logowanie" onClick={rememberDemoMaturaReturnPath} style={{ textDecoration: "none" }}>
            Zaloguj się
          </Link>
          <Link className="btn-primary" to="/rejestracja" onClick={rememberDemoMaturaReturnPath} style={{ textDecoration: "none" }}>
            Załóż bezpłatne konto
          </Link>
        </div>
      </aside>

      {demoExpired && showExpiredDialog ? (
        <div
          role="dialog"
          aria-modal="true"
          aria-labelledby="matura-demo-ended-title"
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 10000,
            display: "grid",
            placeItems: "center",
            padding: 20,
            background: "rgba(0, 0, 0, 0.76)",
            backdropFilter: "blur(8px)",
          }}
        >
          <section
            className="demo-matura-ended-dialog"
            style={{
              width: "min(520px, 100%)",
              padding: "24px",
              borderRadius: 8,
              border: "1px solid rgba(255, 167, 38, 0.8)",
              textAlign: "center",
            }}
          >
            <h2 id="matura-demo-ended-title" style={{ margin: "0 0 10px" }}>
              Demo dobiegło końca
            </h2>
            <p style={{ margin: "0 auto 18px", maxWidth: 430, lineHeight: 1.5, opacity: 0.84 }}>
              Załóż bezpłatne konto, aby kontynuować naukę i zapisywać wyniki,
              podejścia do quizów oraz postęp na ścieżce.
            </p>
            <div style={{ display: "flex", justifyContent: "center", gap: 10, flexWrap: "wrap" }}>
              {allowAdminReset ? (
                <button type="button" className="btn-secondary" onClick={resetDemoTimer}>
                  Odśwież demo na 10 min
                </button>
              ) : null}
              <Link className="btn-secondary" to="/logowanie" onClick={rememberDemoMaturaReturnPath} style={{ textDecoration: "none" }}>
                Zaloguj się
              </Link>
              <Link className="btn-primary" to="/rejestracja" onClick={rememberDemoMaturaReturnPath} style={{ textDecoration: "none" }}>
                Załóż bezpłatne konto
              </Link>
            </div>
          </section>
        </div>
      ) : null}
    </>
  );
}
